import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { LogIn, ShieldCheck } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

export default function AdminLogin() {
  const { login, user } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ username: 'admin', password: '' });
  const [err, setErr] = useState('');
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setErr(''); setLoading(true);
    try {
      const data = await login(form.username, form.password);
      nav(data.must_change_password ? '/admin/change-password' : '/admin');
    } catch (e2) {
      setErr(e2.response?.data?.detail || 'Login failed');
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-forest-950 px-4">
      <form onSubmit={submit} className="w-full max-w-md bg-forest-900 border border-forest-800 p-8 shadow-2xl">
        <div className="flex items-center gap-3 mb-6">
          <ShieldCheck className="h-7 w-7 text-sage-400" />
          <div>
            <h1 className="font-serif text-cream-50 text-2xl">Admin Sign In</h1>
            <p className="text-cream-100/60 text-sm">Perrin Myddelton CMS</p>
          </div>
        </div>
        {err && <div className="mb-4 border border-red-500/40 bg-red-500/10 text-red-300 text-sm px-3 py-2">{err}</div>}
        <label className="block text-xs uppercase tracking-[0.2em] text-cream-100/60 mb-2">Username</label>
        <input value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} className="w-full bg-forest-950 border border-forest-700 focus:border-sage-500 outline-none px-4 py-3 text-cream-50 text-sm" required autoFocus />
        <label className="block text-xs uppercase tracking-[0.2em] text-cream-100/60 mb-2 mt-4">Password</label>
        <input type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="w-full bg-forest-950 border border-forest-700 focus:border-sage-500 outline-none px-4 py-3 text-cream-50 text-sm" required />
        <button disabled={loading} className="mt-6 w-full inline-flex items-center justify-center gap-3 bg-sage-500 text-forest-900 py-3 text-sm font-medium hover:bg-sage-600 transition-colors disabled:opacity-60">
          <LogIn className="h-4 w-4" /> {loading ? 'Signing in…' : 'Sign In'}
        </button>
        <p className="mt-6 text-xs text-cream-100/50 text-center">Default credentials are set in the environment. Change your password on first login.</p>
      </form>
    </div>
  );
}
